
import { Component, Vue, Ref } from 'vue-property-decorator'
import { UserService } from '@/services/index'
import UserTable from './components/userTable.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'UserList',
    components: {
        UserTable,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private users = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private contact = 3
    private regPlatform = ''
    private loading = true
    private curType = 'all'
    private searchInput = ''
    private certStatus = -1
    private searchType = 'username'
    private searchTypeOptions = [
        { key: 'username', value: '用户名' },
        { key: 'phone', value: '手机号' },
        { key: 'company', value: '单位名' }
    ]
    private mapIdentities: any = {
        media: 0,           // 媒体人
        pr: 1,              // 品牌方/政务人士 
        expert: 2,          // 专家学者
        others: 3           // 其它
    }
    private TypeOptions = [
        { key: 'all', value: '所有身份' }, 
        { key: 'media', value: '媒体人' }, 
        { key: 'pr', value: '品牌方/政务人士 ' }, 
        { key: 'expert', value: '专家学者' }, 
        { key: 'others', value: '其他' }
    ]
    private dateTimeVal = ''
    private actDateTimeVal = ''
    private dateTime = { start: '', end: '' }
    private activeDateTime = { start: '', end: '' }

    private mounted() {
        this.getUsers()
    }

    private async getUsers(type: string = '') {
        const identity = this.mapIdentities[this.curType]
        const name = type === 'username' ? this.searchInput : '' 
        const mobile = type === 'phone' ? this.searchInput : ''
        const company = type === 'company' ? this.searchInput : ''
        const certStatus = this.certStatus === -1 ? undefined : this.certStatus
        const pageIndex = this.pageIndex
        const params = {
            identity,
            name,
            mobile,
            company,
            cert_status: certStatus,
            page_index: pageIndex, 
            page_size: this.pageSize,
            is_contacted: this.contact,
            register_platform: this.regPlatform,
            created_at_gte: this.dateTime.start,
            created_at_lte: this.dateTime.end,
            active_start_at: this.activeDateTime.start,
            active_end_at: this.activeDateTime.end
        }
        this.loading = true
        const result = await UserService.getNmUsers(params)
        this.loading = false
        if (result.status === 200) {
            this.users = result.data.users
            this.pageTotal = result.data.page_total
        }
    }


    private onTypeSelect() {
        this.resetCondition()
        this.getUsers(this.searchType)
    }

    private onCurrentChange(page: any) {
        this.pageIndex = page
        this.scrollEl.scrollToTop(() => this.getUsers(this.searchType))
    }

    private onSearch() {
        const val = this.searchInput
        const isPhone = this.searchType === 'phone'
        if (
            (isPhone && !Number.isInteger(+val)) || 
            (isPhone && val.length > 11)
        ) {
            return this.$message({
                type: 'warning',
                message: '请输入正确的手机号码'
            })
        }
        this.resetCondition()
        this.getUsers(this.searchType)
    }

    private onContactChange() {
        this.resetCondition()
        this.getUsers()
    }

    private onCertChange() {
        this.resetCondition()
        this.getUsers()
    }

    private onRegPlatformChange() {
        this.resetCondition()
        this.getUsers()
    }

    private onDateTimeSelect(dateTime: string[]) {
        dateTime = dateTime || []
        const [start, end] = dateTime
        this.dateTime.start = start
        this.dateTime.end = end
        this.resetCondition()
        this.getUsers()
    }

    private onActDateTimeSelect(actDateTime: string[]) {
        actDateTime = actDateTime || []
        const [start, end] = actDateTime
        this.activeDateTime.start = start
        this.activeDateTime.end = end
        this.resetCondition()
        this.getUsers()
    }
    resetCondition() {
        this.pageIndex = 1
    }
}
